module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Treasure in Heaven: Live, Love, and Prosper")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-1"
    }
  }, [_vm._v("Chapter 1: "), _c('span', [_vm._v("Our Challenges on Earth")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#our-challenges-on-earth"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: "), _c('span', [_vm._v("Participation in the Plan")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#participation-in-the-plan",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: "), _c('span', [_vm._v("Horizontal Decision-Making")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#horizontal-decision-making",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: "), _c('span', [_vm._v("Freedom of Conscience")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#freedom-of-conscience",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: "), _c('span', [_vm._v("Vertical Decision-Making and Horizontal Decision-Making")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#vertical-decision-making-and-horizontal-decision-making",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: "), _c('span', [_vm._v("Horizontal Decision-Making Through Personal Contacts")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#horizontal-decision-making-through-personal-contacts",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: "), _c('span', [_vm._v("Reaction versus Planning")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#reaction-versus-planning",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: "), _c('span', [_vm._v("Horizontal Decision-Making and Preparedness")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#horizontal-decision-making-and-preparedness",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: "), _c('span', [_vm._v("Vertical Decision-Making")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#vertical-decision-making",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: "), _c('span', [_vm._v("Seek Ye Treasure in Heaven")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#seek-ye-treasure-in-heaven",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: "), _c('span', [_vm._v("Financial Decision-Making and Charitable Donations")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#financial-decision-making-and-charitable-donations",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: "), _c('span', [_vm._v("Financial Language and Communication for Unity")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#financial-language-and-communication-for-unity",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: "), _c('span', [_vm._v("Our Feelings About Financial Decisions")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#our-feelings-about-financial-decisions",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: "), _c('span', [_vm._v("Theories of the World")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#theories-of-the-world",
      "title": "Link target outside of Sample"
    }
  }), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#political-theories",
      "title": "Link target outside of Sample"
    }
  })])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: "), _c('span', [_vm._v("Reporting Almsgiving")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#reporting-almsgiving",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: "), _c('span', [_vm._v("Collective Almsgiving")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#collective-almsgiving",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: "), _c('span', [_vm._v("Qualities that Impact Financial Decision-Making")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#qualities-that-impact-financial-decision-making",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: "), _c('span', [_vm._v("Internal Motivation")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#internal-motivation",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: "), _c('span', [_vm._v("Love of Money")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#love-of-money",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: "), _c('span', [_vm._v("Trust in Money")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#trust-in-money",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: "), _c('span', [_vm._v("Trust in Self")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#trust-in-self",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: "), _c('span', [_vm._v("Trust in Self Leads to Ingratitude")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#trust-in-self-leads-to-ingratitude",
      "title": "Link target outside of Sample"
    }
  }), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#haman",
      "title": "Link target outside of Sample"
    }
  })])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: "), _c('span', [_vm._v("Trust in Others")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#trust-in-others",
      "title": "Link target outside of Sample"
    }
  }), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#are-our-jobs-secure",
      "title": "Link target outside of Sample"
    }
  })])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: "), _c('span', [_vm._v("Other Distortions")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#other-distortions",
      "title": "Link target outside of Sample"
    }
  }), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#consumers",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#rescuer",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#absence-of-decision-making",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#shortcuts",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#contrast-to-short-cuts-counsel-decision-making",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#lost-in-service",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#short-cuts-story-of-moses",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#the-hoarder",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#someone-has-to-lose",
      "title": "Link target outside of Sample"
    }
  })])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: "), _c('span', [_vm._v("Encumbered by Physical Possessions")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#encumbered-by-physical-possessions",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: "), _c('span', [_vm._v("Financial Almsgiving")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#financial-almsgiving",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: "), _c('span', [_vm._v("Public Almsgiving")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#public-almsgiving",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: "), _c('span', [_vm._v("Attitude About Work")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#attitude-about-work",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: "), _c('span', [_vm._v("Retirement – A State of Mind")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#retirement-a-state-of-mind",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: "), _c('span', [_vm._v("Back to Retirement – Plan for Your Future")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#back-to-retirement-plan-for-your-future",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: "), _c('span', [_vm._v("Pride Interferes")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#pride-interferes",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: "), _c('span', [_vm._v("Building Up the Kingdom of God")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#building-up-the-kingdom-of-god",
      "title": "Link target outside of Sample"
    }
  }), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#the-law-of-the-fast",
      "title": "Link target outside of Sample"
    }
  })])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: "), _c('span', [_vm._v("Participating in the Kingdom of God")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#participating-in-the-kingdom-of-god",
      "title": "Link target outside of Sample"
    }
  })])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#chapter-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: "), _c('span', [_vm._v("Building the Kingdom of God Requires Repentance")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#building-the-kingdom-of-god-requires-repentance",
      "title": "Link target outside of Sample"
    }
  }), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#repentance-while-operating-in-a-group",
      "title": "Link target outside of Sample"
    }
  })])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#chapter-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: "), _c('span', [_vm._v("Horizontal Communication is Different than Horizontal Decision-Making")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#horizontal-communication-is-different-than-horizontal-decision-making",
      "title": "Link target outside of Sample"
    }
  }), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#individual-program-of-development",
      "title": "Link target outside of Sample"
    }
  })]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#perfecting-the-saints-through-a-group",
      "title": "Link target outside of Sample"
    }
  })])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0